"use client";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { preprocessMathContent } from "@/app/lib/markdownPreprocessor";
import { ChatLoadingSkeleton } from "@/app/components/ui";

const IMAGE_DEBUG_HINT_REGEX =
   /image\s*:|<img\b|ckeditor-files|https?:\/\/\S+\.(?:png|jpe?g|gif|webp|svg)/i;

interface LoadingMessageProps {
   streamingResponse: string;
   translate: (key: string) => string;
}

export const LoadingMessage = ({ streamingResponse, translate }: LoadingMessageProps) => {
   const processedStreamingResponse = streamingResponse
      ? preprocessMathContent(streamingResponse)
      : "";

   if (
      process.env.NODE_ENV === "development" &&
      streamingResponse &&
      IMAGE_DEBUG_HINT_REGEX.test(streamingResponse)
   ) {
      console.debug("[Streaming markdown image debug]", {
         rawContent: streamingResponse,
         processedContent: processedStreamingResponse
      });
   }

   return (
      <div className="flex justify-start group">
         <div
            className={`rounded-lg sm:rounded-2xl overflow-hidden ${
               streamingResponse
                  ? "max-w-[90%] sm:max-w-[85%] bg-white dark:bg-gray-800 p-1.5 sm:p-3"
                  : "w-full"
            }`}
         >
            <ChatLoadingSkeleton
               hasStreamingContent={!!streamingResponse}
               translate={translate}
            />

            {streamingResponse && (
               <div>
                  <ReactMarkdown
                     remarkPlugins={[remarkGfm]}
                     rehypePlugins={[rehypeRaw]}
                     className="prose prose-sm md:prose-base dark:prose-invert max-w-full"
                  >
                     {processedStreamingResponse}
                  </ReactMarkdown>
               </div>
            )}
         </div>
      </div>
   );
};

export default LoadingMessage;
